<div
  id="ankuendigungsPopup"
  [class.mobil]="environment.type == 'mobil'"
  [class.web]="environment.type == 'web'"
>
  <div id="ankuendigungsContent" class="contentblock" *ngIf="werbePopupContent" [innerHTML]="werbePopupContent | img | async"></div>
</div>
